"use client"

import React from "react";
import { useTranslations } from "next-intl";
import cn from "classnames";
import {
    Spin,
    Typography
} from "antd";
import style from "./supportCountry.module.scss";
import {
    Card,
    Table,
} from "@/theme/ui";
import {
    useApi,
    useTempData
} from "@/lib/hook";
import {CountrySelect} from "@/components";
const { Text } = Typography;

const initFilterData = {
    country_id: 202,
}

export const SupportCountry = () => {
    const tR = useTranslations('reports.support_country');
    const t = useTranslations('support');
    const {data: tempData, setTempData} = useTempData('support_country', initFilterData);
    const statuses = [
        {
            label: 'total',
            value: tR('created'),
            checked: false
        },
        {
            label: 'progress',
            value: t('progress'),
            checked: false
        },
        {
            label: 'completed',
            value: tR('completed'),
            checked: false
        },
    ];
    const { data: data, isFetching } = useApi({
        route: {
            name: 'reports.country',
        },
        data: {...tempData},
        setting: {
            select: (resp) => resp,
        },
    });

    const getStatus = (item) => {
        let result = statuses.filter(filt => filt.label === item.toLowerCase());

        return result[0].value;
    }

    const columns = [
        {
            title: tR('status'),
            dataIndex: 'type',
            maxWidth: '160px',
            render: (item) => {
                return (
                    <Text className={style.td}>
                        {getStatus(item)}
                    </Text>
                )
            }
        },
        {
            title: tR('count'),
            dataIndex: 'value',
            maxWidth: '146px',
            render: (item) => {
                return (
                    <Text className={style.td}>
                        {item}
                    </Text>
                )
            }
        },
        {
            title: '%',
            dataIndex: 'percent',
            maxWidth: '146px',
            render: (item) => {
                return (
                    <Text className={style.td}>
                        {item + '%'}
                    </Text>
                )
            }
        },
    ];

    const onChangeCountry = (value) => {
        setTempData({
            country_id: value
        })
    }

    return (
        <>
            <div className={cn(style.block, 'support_block')}>
                <Card
                    className={'charts'}
                >
                    <Spin spinning={isFetching}>
                        <div
                            className={style.title}
                        >
                            {tR('title')}
                        </div>
                        <p
                            className={style.description}
                        >
                            {tR('country')}
                        </p>
                        <CountrySelect
                            isCountryStatistic={true}
                            onChange={onChangeCountry}
                            value={tempData.country_id}
                        />
                        <Table
                            dataSource={data ?? []}
                            rowKey={'id'}
                            columns={columns}
                            expandable={{
                                showExpandColumn: false
                            }}
                        />
                    </Spin>
                </Card>
            </div>
        </>
    );
}